// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.logos.RentalManagerUserPropertyLogoV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyLogoV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyLogoDeleteV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyLogoV2WebApiHandler_delete_Args {
  postData: UserPropertyLogoDeleteV2RequestDto;
}

export type RentalManagerUserPropertyLogoV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyLogoV2WebApiHandler_delete_Args
>;

/**
 * Delete a property logo
 */
export const useRentalManagerUserPropertyLogoV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyLogoV2WebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyLogoV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyLogoV2WebApiHandler_delete(args.postData, httpClient),
  });
};
